<template>
  <AppDialog v-model="model" width="800" :value="true">
    <VCard>
      <VCardTitle class="dialog-header mb-1">{{ $t('title') }}</VCardTitle>
      <VDivider />
      <VCardText class="pt-6 pb-7">
        <CandidateInterviewCopyLink :link="link" />
      </VCardText>
    </VCard>
  </AppDialog>
</template>

<script>
import CandidateInterviewCopyLink from '@/components/Candidate/CandidateInterviewCopyLink';
import AppDialog from '@/components/AppDialog';

export default {
  name: 'VacancyListItemSocialDialog',
  components: { AppDialog, CandidateInterviewCopyLink },
  props: {
    link: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
    },
  },
  computed: {
    model: {
      set(val) {
        this.$emit('input', val);
      },
      get() {
        return this.value;
      },
    },
  },
};
</script>

<style scoped lang="scss">
.dialog-header {
  font-weight: 400;
  min-height: 50px;
  justify-content: center;
}
@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .dialog-header {
    min-height: 2.5rem;
  }
}
</style>

<i18n lang="yml" locale="ru">
  title: Нанимайте прямо из ваших аккаунтов в социальных сетях
</i18n>
<i18n lang="yml" locale="en">
  title: Hire from your socials
</i18n>
